import { createRequestTypes } from '../utils';

export const TASK_LIST = createRequestTypes('task/TASK_LIST');
export const SAVE_TASK = createRequestTypes('task/SAVE_TASK');
export const SAVE_MULTIPLE_TASKS = createRequestTypes('task/SAVE_MULTIPLE_TASKS');
export const DELETE_TASK = createRequestTypes('task/DELETE_TASK');
export const UPDATE_TASK_STATUS = createRequestTypes('task/UPDATE_TASK_STATUS');
export const START_TASK = createRequestTypes('task/START_TASK');
export const STOP_TASK = createRequestTypes('task/STOP_TASK');
